import './App.css';
import "./components/header/header.css"

import React from "react"

import Container from "./components/Container"
import Container2 from "./components/Container2"
import Container3 from "./components/Container3"

import createUserObject from "./createUserObject"
import localPokemonData from "./pokemon-data.json"
import { useAuth0 } from "@auth0/auth0-react"

function App() {
  const [section, setSection] = React.useState(0)
  const [i, setIndex] = React.useState(0)
  const [localData, setLocalData] = React.useState(localPokemonData[i])
  const [apiData, setData] = React.useState([])
  const [moves, setMoves] = React.useState({})

  //este state booleano es para la animacion del salto
  const [state, setState] = React.useState(true)
  // y este para las habilidades
  const [skillData, setSkillData] = React.useState([])

  //authentication
  const { isAuthenticated, user } = useAuth0();
  if (isAuthenticated) {
    console.log(user)
    if(localPokemonData.length < 6){
      localPokemonData.push(createUserObject())
    }
  }

  
  const obtenerDatos = async (pokemon) => {
    const data = await fetch(`https://pokeapi.co/api/v2/pokemon/${pokemon}`);
    const pokemonData = await data.json();
    const ability = await fetch(pokemonData.abilities[0].ability.url)
    const abilityData = await ability.json();

    setSkillData(abilityData)
    setData(pokemonData)
  }
  const setAllData = (index) =>{
    setIndex(index);
    obtenerDatos(localPokemonData[i].name)
    setLocalData(localPokemonData[i])
    setState(true)  
    setTimeout(() => {
      setState(false)
    }, 700)
  }

  React.useEffect(() => { 
    let movesCopy = {}
    obtenerDatos(localPokemonData[0].name);
    localPokemonData.forEach(x =>{
      x.movesKnown.forEach(async (move) =>{
        const moveObj = await fetch(`https://pokeapi.co/api/v2/move/${move}`)
        const moveJson = await moveObj.json();
        movesCopy[move] = moveJson;
        setMoves(movesCopy)
      })
    })
    setTimeout(() => {
      setState(false)
    }, 700);
  }, [])


const pkmup = ()=>{
    if(localPokemonData[i + 1]){
      setAllData(i+1)
    }
    else {
      setAllData(0)
    }
    
}
const pkmdown = () =>{

  if(localPokemonData[i - 1]){
    setAllData(i-1)
  }
  else {
    setAllData(localPokemonData.length - 1)
  }
}


  if(section === 0){
    return (
      <>
        <div className="up change-btn" onClick={pkmup}><span>↑</span></div>
          <Container section={section} apiData = {apiData} localData = {localData} state={state} setSection={setSection} ></Container>
        <div className="down change-btn" onClick={pkmdown}><span>↓</span></div>
      </>
    )

   
  }
  else if (section === 1){
    return(
      <>
        <div className="up change-btn" onClick={pkmup}><span>↑</span></div>

        <Container2 skillData={skillData} section={section} apiData={apiData} localData={localData} state={state} setSection={setSection} ></Container2>

        <div className="down change-btn" onClick={pkmdown}><span>↓</span></div>
      </>
    )
  }
  else if (section === 2) {
    return (
      <>
        <div className="up change-btn" onClick={pkmup}><span>↑</span></div>

        <Container3 section={section} apiData={apiData} localData={localData} state={state} setSection={setSection} moves={moves} ></Container3>

        <div className="down change-btn" onClick={pkmdown}><span>↓</span></div>
      </>
    )
  }


}


export default App;
